module.exports = __webpack_public_path__ + "files/3916eb33932366aa36ee18c8a23640e0.png";